import axios from "axios";
import { multipartUpload } from "./oss"

export async function uploadFile(type, { raw, name, id }, onProgress) {
    let res = await axios.post("file", raw, {
        params: {
            id,
            type,
            fileName: name
        },
        onUploadProgress(event) {
            onProgress ? onProgress(event.loaded / event.total) : null
        }
    })

    return res.data
}

export async function uploadTemp({ raw, name }, onProgress) {
    let res = await axios.post("file/temp", raw, {
        params: {
            fileName: name
        },
        onUploadProgress(event) {
            onProgress ? onProgress(event.loaded / event.total) : null
        }
    })

    return res.data
}

export async function asyncUploadTemp({ raw, name }, onProgress) {
    let res = await axios.get("file/temp/async", {
        params: {
            fileName: name
        }
    })

    if (res.data.type == "local") {
        await axios.post("file/temp", raw, {
            params: {
                fileName: name
            },
            onUploadProgress(event) {
                onProgress ? onProgress(event.loaded / event.total) : null
            }
        })

        return res.data
    }

    if (res.data.type == "oss") {
        await multipartUpload(raw, onProgress, res.data)
        return res.data
    }

    throw { message: "不能识别存储类型", res: res.data }
}


// WEBPACK FOOTER //
// ./src/fs/index.js